import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLD from '@/components/base/JsonLD';
import OverpaymentCalculator from './components/OverpaymentCalculator';
import Breadcrumb from '@/components/base/Breadcrumb';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Kalkulator nadpłaty kredytu – ile zyskasz nadpłacając? | EXPERT KREDYTOWY',
  description:
    'Sprawdź ile lat i tysięcy złotych zaoszczędzisz nadpłacając kredyt hipoteczny. Kalkulator nadpłaty z pełną symulacją harmonogramu. Bezpłatna konsultacja z doradcą kredytowym Janem Wojdyłą w Sanoku.',
  url: 'https://kredytpodkarpacie.pl/narzedzia/nadplata-kredytu',
  isPartOf: {
    '@type': 'WebSite',
    name: 'EXPERT KREDYTOWY',
    url: 'https://kredytpodkarpacie.pl',
  },
};

export default function NadplataPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLD data={schema} />
      <Navbar />
      <div className="pt-16 md:pt-20">
        <div className="px-4 md:px-8 lg:px-12 mb-4">
          <Breadcrumb />
        </div>
        <main>
          <OverpaymentCalculator />
        </main>
      </div>
      <p className="text-center text-[10px] text-foreground-400 py-4 mx-auto max-w-[1440px] px-4 md:px-8 lg:px-16 xl:px-20">
        Zabrania się kopiowania i wykorzystywania | Orsonet Studio 2026
      </p>
      <Footer />
    </div>
  );
}
